// extracted by mini-css-extract-plugin
export default {"notFoundPage":"notFound_notFoundPage__+x0H7","description":"notFound_description__4wteh","boldLabel":"notFound_boldLabel__bTHxy"};